import type { PresetInput, TimerPreset } from '@pomodingo/api-client';
import { apiJson } from './api';

export type { PresetInput, TimerPreset };

export function listPresets(): Promise<TimerPreset[]> {
  return apiJson<{ presets: TimerPreset[] }>('/api/presets').then(
    (data) => data.presets,
  );
}

export function createPreset(input: PresetInput): Promise<TimerPreset> {
  return apiJson<{ preset: TimerPreset }>('/api/presets', {
    method: 'POST',
    body: JSON.stringify(input),
  }).then((data) => data.preset);
}

export function deletePreset(id: string): Promise<void> {
  return apiJson(`/api/presets/${encodeURIComponent(id)}`, {
    method: 'DELETE',
  }).then(() => undefined);
}
